/**
 * 抽象数据结构(ADT) -- 树
 */

import adtBase from '../base';

class Tree extends adtBase.BaseADT
{
  getRootNode()
  {
    //TODO implement me
  }
};

class TreeNode extends adtBase.BaseADT
{
  constructor(data)
  {
    super();
    this._children = [];
    this._parent = null;
    this._data = data;
  }
  get children()
  {
    return this._children;
  }
  clearChildren()
  {
    let oldChildren = this._children;
    this._children = [];
    return oldChildren;
  }
  get parent()
  {
    return this._parent;
  }
  set parent(val)
  {
    this._parent = val;
  }
  get data()
  {
    return this._data;
  }
  set data(val)
  {
    this._data = val;
  }
  insertChild(child, index)
  {
    index = index || this.children.length;
    index = Math.max(0, index);
    if (undefined === child)
    {
      return -1;
    }
    if (this.children.indexOf(child) != -1)
    {
      return -1;
    }
    child.parent = this;
    this.children.splice(index, 0, child);
    return index;
  }
};
/**
 * 工具类函数：美化打印树结构
 */
let utils = {
};
export default {
  Tree,
  TreeNode,
};



// WEBPACK FOOTER //
// ./src/foundation/adt/tree/index.js